import DelegationPermissionBadges from "../../delegation/DelegationPermissionBadges";
import { DelegationHistoryModel } from "../../../interfaces/delegation";
import { formatDanishDateTime, formatDanishLongDate } from "../../../util/date";

interface DelegationHistoryTableProps {
  delegations: DelegationHistoryModel[];
}

const getStatusBadge = (status: string) => {
  switch (status) {
    case "Revoked":
      return { label: "Tilbagekaldt", className: "badge-danger" };
    case "Expired":
      return { label: "Udløbet", className: "badge-secondary" };
    default:
      return { label: status, className: "badge-light" };
  }
};

const DelegationStatusBadge = ({ status }: { status: string }) => {
  const { label, className } = getStatusBadge(status);
  return <span className={`badge ${className}`}>{label}</span>;
};

const DelegationHistoryTable = ({
  delegations,
}: DelegationHistoryTableProps) => {
  if (delegations.length === 0) {
    return <p className="text-muted mb-0">Ingen tidligere fuldmagter.</p>;
  }

  return (
    <div className="table-responsive">
      <table className="table table-sm align-middle mb-0">
        <thead>
          <tr>
            <th scope="col">Fuldmægtig</th>
            <th scope="col">Rettigheder</th>
            <th scope="col">Gyldig fra</th>
            <th scope="col">Gyldig til</th>
            <th scope="col">Modtager</th>
            <th scope="col">Betegnelse</th>
            <th scope="col">Status</th>
            <th scope="col">Afsluttet</th>
          </tr>
        </thead>
        <tbody>
          {delegations.map((delegation) => (
            <tr key={delegation.id}>
              <td>{delegation.delegateDisplayName}</td>
              <td>
                <DelegationPermissionBadges
                  permissions={delegation.permissions}
                />
              </td>
              <td>{formatDanishDateTime(delegation.validFrom)}</td>
              <td>
                {delegation.validTo
                  ? formatDanishLongDate(delegation.validTo)
                  : "—"}
              </td>
              <td>{delegation.invitedName || "—"}</td>
              <td>{delegation.invitedLabel || "—"}</td>
              <td>
                <DelegationStatusBadge status={delegation.status} />
              </td>
              <td>
                {delegation.revokedAt
                  ? formatDanishDateTime(delegation.revokedAt)
                  : delegation.validTo
                    ? formatDanishLongDate(delegation.validTo)
                    : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DelegationHistoryTable;
